<template>
    <nav class="sidebar" :class="{'toggled-on-mobile': toggledOnMobile}">
        <div class="content-wrapper">
            <router-link v-if="isMobile && !isSupervisor" to="/MobileDashboard" class="logo-url">
                <img src="@/assets/images/backoffice.png" alt="logo" />
            </router-link>
            <router-link v-else to="/Webshops" class="logo-url">
                <img src="@/assets/images/backoffice.png" alt="logo" />
            </router-link>

            <div class="side-menu">
                <side-menu-item
                    v-for="(item, index) in items"
                    :key="index"
                    :text="item.title"
                    :icon="item.icon"
                    :routerLink="item.routerLink"
                    :outlined="item.outlined"
                    :subItems="item.subItems"
                    :hideSideMenuIfMobile="() => showSidebarOnMobile = false"
                    @clicked="$emit('closeOverlay')"
                ></side-menu-item>
            </div>
        </div>
    </nav>
</template>

<script>
import SideMenuItem from './SideMenuItem.vue'

export default {
    components: {
        SideMenuItem,
    },
    props: {
        toggledOnMobile: Boolean,
    },
    data() {
        return {
            isMobile: 
                navigator.userAgent.match(/Android/i) ||
                navigator.userAgent.match(/webOS/i) ||
                navigator.userAgent.match(/iPhone/i) ||
                navigator.userAgent.match(/iPad/i) ||
                navigator.userAgent.match(/iPod/i) ||
                navigator.userAgent.match(/BlackBerry/i) ||
                navigator.userAgent.match(/Windows Phone/i),
        }
    },
    computed: {
        //change the layout here
        items() {
            var items = [
                {
                    title: this.$t('MENU__WEBSHOPS'),
                    icon: 'business',
                    routerLink: '/WebShops',
                },
                {
                    title: this.$t('MENU__ACCOUNT_CARDS'),
                    icon: 'credit_card',
                    routerLink: '/AccountCards',
                },
                {
                    title: this.$t('MENU__PREPAID_CARDS'),
                    icon: 'card_membership',
                    routerLink: '/PrepaidCards',
                },
                {
                    title: this.$t('MENU__REPORT'),
                    icon: 'report',
                    routerLink: '/Report',
                },
                {
                    title: this.$t('MENU__GAME_VENDOR_REPORT'),
                    icon: 'bar_chart',
                    routerLink: '/GameVendorReport',
                },
                {
                    title: this.$t('MENU__GENERAL_STATISTICS'),
                    icon: 'bar_chart',
                    routerLink: '/GeneralStatistics',
                },
                {
                    title: this.$t('MENU__USER_STATISTICS'),
                    icon: 'bar_chart',
                    routerLink: '/UserStats',
                },
                {
                    title: this.$t('MENU__WITHDRAWS'),
                    icon: 'transit_enterexit',
                    routerLink: '/Withdraws',
                },
                {
                    title: this.$t('MENU__SPORTSBOOK_BETS'),
                    icon: 'assignment',
                    routerLink: '/Sportsbook',
                },
                {
                    title: this.$t('MENU__CBCX_TICKETS'),
                    icon: 'description',
                    routerLink: '/cbcxTickets'
                },
            ]

            if(!this.isSupervisor) {
                items.push({
                    title: this.$t('MENU__SPORTSBOOK_PAYOUTS'),
                    icon: 'compare_arrows',
                    routerLink: '/SportsBookPayouts',
                })
            }

            return items
        },
        isSupervisor() {
            return this.$store.state.shop
        }
    },
}
</script>

<style scoped lang="scss">
.sidebar {
    .content-wrapper {
        img {
            width: 150 * $rem;
        }
    }
}

nav {
    // overflow: hidden;
    position: fixed;
    left: 0;
    top: 0;
    height: 100vh;
    background-color: white;
    display: block;
    width: 250 * $rem;
    transform: translateX(0);
    z-index: 10;
    transition: transform 0.3s ease-out;

    .content-wrapper {
        position: relative;
        width: 100%;
        height: 100%;

        .logo-url {
            width: 100%;
            padding: 20 * $rem;
            height: 85 * $rem;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            text-align: center;
            background: white;
            display: inline-block;
            text-decoration: none;
            color: inherit;

            img {
                filter: brightness(1.5);
            }
        }

        .toggle-button {
            position: absolute;
            background-color: #ffffff;
            border-radius: 14 * $rem;
            right: -12 * $rem;
            z-index: 149;
            top: 22 * $rem;
            display: flex;
            align-items: center;
            padding: 5 * $rem;
            box-shadow: 0 0 10 * $rem #372727b3;
            cursor: pointer;

            &:hover {
                opacity: 0.8;
            }

            &.toggled {
                right: -24 * $rem;
                padding-left: 15 * $rem;
            }

            i {
                font-size: 18 * $rem;
            }
        }

        .hover-area {
            position: fixed;
            right: -30 * $rem;
            margin-top: 75 * $rem;
            width: 30 * $rem;
            height: calc(100vh - 75 *#{$rem});
            opacity: 0;
        }
    }
}

.show-on-mobile {
    transform: translateX(0);
}

.slide-in {
    transform: translateX(-293 * $rem);
}

@media only screen and (max-width: 1024px) {
    nav {
        transform: translateX(-293 * $rem);
        height: calc(100vh - 60 *#{$rem});
        margin-top: 60 * $rem;
        overflow-y: auto;

        .content-wrapper .toggle-button {
            display: none;
        }
    }

    .toggled-on-mobile {
        transform: translateX(0);
        z-index: 30;
    }
}
</style>
